import { useTranslation } from 'react-i18next'
import { Base } from '@itsrever/design-system'

const { Card, FieldRoot, FieldLabel, FieldDescription, TagInput } = Base

export type FreeTextCopyKey =
  | 'order_tags'
  | 'product_ids'
  | 'collection_ids'
  | 'category_ids'
  | 'tag_ids'
  | 'brand_ids'

// For values the platform can't list for us: the merchant types them as the evaluator compares them.
export const FreeTextListField: React.FC<{
  copyKey: FreeTextCopyKey
  platform?: string
  value: string[]
  onChange: (values: string[]) => void
  canEdit: boolean
  // Where the copy lives, for lists outside Non-returnable items.
  copyPrefix?: string
  // Without its own card, for a list inside another card.
  bare?: boolean
}> = ({
  copyKey,
  platform,
  value,
  onChange,
  canEdit,
  copyPrefix = 'non_returnable',
  bare = false
}) => {
  const { t } = useTranslation()
  // Some platforms compare a different identifier (Shopware product numbers, PrestaShop tag IDs…).
  const copy = (field: string) =>
    t([
      `${copyPrefix}.${copyKey}_${platform}.${field}`,
      `${copyPrefix}.${copyKey}.${field}`
    ])

  const Wrapper = bare ? 'div' : Card
  return (
    <Wrapper
      className={bare ? 'flex flex-col gap-3' : 'flex flex-col gap-3 p-4'}
    >
      <FieldRoot>
        <FieldLabel>{copy('title')}</FieldLabel>
        <FieldDescription>{copy('description')}</FieldDescription>
        <TagInput
          values={value}
          onChange={onChange}
          placeholder={copy('placeholder')}
          emptyText={copy('empty')}
          readOnly={!canEdit}
          removeLabel={(tag) => t('tag_input.remove', { value: tag })}
        />
      </FieldRoot>
    </Wrapper>
  )
}
